import { AccountNoteApiModel } from '../../../api/accountNote/models/accountNote.api.model';

export class AccountNoteModel {
    id?: number;
    value?: string;

    createdUserId?: number;
    creationDate?: Date;

    lastUpdatedByUserId?: number;
    updatedUserName?: string;
    lastUpdatedDate?: Date;

    constructor(apiModel?: AccountNoteApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.value = apiModel.value;
            this.createdUserId = apiModel.createdUserId;
            this.creationDate = new Date(apiModel.creationDate);
            this.lastUpdatedByUserId = apiModel.lastUpdatedByUserId;
            this.updatedUserName = apiModel.updatedUserName;
            this.lastUpdatedDate = new Date(apiModel.lastUpdatedDate);
        }
    }

    toApiModel(): AccountNoteApiModel {
        return {
            value: this.value,
            createdUserId: this.createdUserId,
            creationDate: this.creationDate?.toString(),
            lastUpdatedByUserId: this.lastUpdatedByUserId,
            updatedUserName: this.updatedUserName,
            lastUpdatedDate: this.lastUpdatedDate?.toString()
        };
    }

    clone() {
        return new AccountNoteModel(this.toApiModel());
    }

    equals(other: AccountNoteModel) {
        if (!other) {
            return false;
        }

        return (
            this.createdUserId === other.createdUserId
            && this.creationDate?.toString() === other.creationDate?.toString()
            && this.lastUpdatedByUserId === other.lastUpdatedByUserId
            && this.lastUpdatedDate?.toString() === other.lastUpdatedDate?.toString()
            && this.updatedUserName === other.updatedUserName
            && this.value === other.value
        );
    }
}
